export const LOCALE_COOKIE_NAME = "callo_locale"
export const LOCALE_STORAGE_KEY = "callo_locale"
export const DEFAULT_LOCALE = "fr"